import { StopAppointment } from '~/domain/usecases/appointment/remote';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import {
  NotFound,
  UnexpectedError,
  Forbidden,
  AccessDeniedError,
} from '~/domain/errors';
import '~/infra/global/variables';

export class RemoteStopAppointment implements StopAppointment {
  private readonly url: string;

  private readonly httpClient: HttpClient<StopAppointment.Model>;

  constructor(url: string, httClient: HttpClient<StopAppointment.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  stop = async (
    params: StopAppointment.Params,
  ): Promise<StopAppointment.Model> => {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${params.id}/stop`,
      method: 'patch',
      body: {
        outcome: params.outcome,
      },
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new AccessDeniedError();
      case HttpStatusCode.forbidden:
        throw new Forbidden();
      case HttpStatusCode.notFound:
        throw new NotFound();
      default:
        throw new UnexpectedError();
    }
  };
}
